<div class="app-content content">
    <div class="content-wrapper">
      <div class="content-header row mb-1">
      </div>
      <div class="content-detached">
        <div class="content-body">
          <div class="content-overlay" id='content-overlay' (click)="contentOverlay($event)"></div> 
          <section id="offers-available" class="row">
            <div class="col">
              <div class="card">
                <div class="card-head">
                  <div class="card-header bg-gradient-x-success">
                    <h2 class="text-bold-600 text-white">Buscar egresado</h2>
                    <form [formGroup]="searchForm" class="form form-horizontal" >
                    <div class="form-body">
                    <div class="row">
                      <div class="col-md-6 col-sm-12">
                        <div class="form-group position-relative">
                          <input id="typeahead-focus" [maxlength]="15" formControlName="username" type="text" class="form-control round text-uppercase"
                              placeholder="Mátricula" />
                          <small class="form-text text-muted danger" 
                            class="invalid-feedback">
                            <div>El campo de búsqueda es requerido.</div>
                          </small>
                        </div>
                      </div>
                      <div class="col-md-4 col-sm-12">
                        <div class="form-group">
                          <button type="submit" (click)="searchUser()" class="btn btn-secondary btn-block btn-glow text-uppercase">
                            <h5 class="text-white font-bold-600">Buscar</h5></button>
                        </div>
                      </div>
                    </div>
                    </div>
                    </form>
                  </div>
                </div>
                <div class="card-content" *ngIf="graduated && hasSearch">
                  <div class="card-body">
                    <div class="media-body p-2">
                      <div class="row align-items-center">
                        <div class="col-sm-12 col-md-4 col-lg-4">
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                          <div class="form-group">
                            <button type="submit" (click)="reset()" class="btn btn-warning btn-block btn-glow text-uppercase">
                              <h5 class="text-white font-bold-600">Mostrar todas las postulaciones</h5></button>
                          </div>
                        </div>
                        <div class="col-sm-12 col-md-4 col-lg-4">
                        </div>
                      </div>
                    </div>
                    <h3 class="text-bold-500">Egresado encontrado</h3>          
                    <div class="row">
                        <div class="col-12">
                          <div class="card overflow-hidden callout-border-left">
                            <div class="card-content">
                              <div class="media align-items-stretch">
                                <div class="p-2 media-middle rounded-left" *ngIf="graduated?.imgUrl">
                                    <img [src]=graduated.imgUrl style="width: 60px; height: 60px;">
                                </div>
                                <div class="p-2 media-middle rounded-left" *ngIf="!graduated?.imgUrl">
                                    <img src="https://res.cloudinary.com/drtcnv1st/image/upload/v1678471683/Graduados/No_image_available.svg_xvejcl.png" style="width: 60px; height: 60px;">
                                </div>
                                <div class="media-body p-2">
                                  <h5 class="offer-description">último acceso: {{convertDate(graduated.ultimoAccesoSistema)}}</h5>
                                  <h4 class="text-uppercase text-bold-600">{{graduated.nombre}}</h4>
                                </div>
                              </div>
                              
                            </div>
                          </div>
                          <div>
                            <div class="table-responsive card-body">
                              <div class="card-header" *ngIf="responseBySearch!=null && responseBySearch?.length>0">
                                <h5 class="content-header-title card-title">Listado de postulaciones realizadas por {{graduated.nombre}}.</h5>
                              </div>
                              <div *ngIf="responseBySearch === null || responseBySearch?.length === 0"
                                class="bs-callout-info callout-round callout-bordered mt-1">
                                  <div class="media align-items-stretch">
                                    <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                                      <i class="la la-ban white font-medium-5"></i>
                                    </div>
                                    <div class="media-body p-1">
                                      <h4 class="info">No hay registros</h4>
                                      <p>Aún no hay registro de postulaciones realizadas por el egresado.
                                      </p>
                                    </div>
                                  </div>
                              </div>
                              <table *ngIf="responseBySearch != null || responseBySearch?.length > 0"
                                class="table table-column table-hover">
                                  <thead class="thead bg-blue1">
                                    <tr>                    
                                      <th scope="col">
                                        <h5 class="text-bold-600">Puesto</h5></th>
                                      <th scope="col">
                                        <h5 class="text-bold-600">Lugar</h5></th>
                                      <th scope="col">
                                        <h5 class="text-bold-600">Detalles Oferta</h5></th>
                                      <th scope="col">
                                        <h5 class="text-bold-600">Fecha de postulación</h5></th>
                                      <th scope="col">
                                        <h5 class="text-bold-600">Fecha de aceptación</h5></th>
                                      <th scope="col" class="col-sm-3">
                                        <h5 class="text-bold-600">Estado de vacante</h5></th>
                                      </tr>
                                  </thead>
    
                                  <tbody *ngFor="let egresado of responseBySearch;">
                                    <tr class="ng-star-inserted">
                                      <td scope="row">{{ egresado?.descripcionPuesto }}</td>  
                                      <th scope="row">{{ egresado?.lugar }}</th>
                                      <td scope="row" class="text-center">
                                        <button type="button" class="btn btn-icon btn-primary mr-1" (click)="openDetailOffer(egresado?.idOferta)"
                                        triggers="hover:click:hover" placement="top"
                                        ngbPopover="Consulta información más detallada acerca de la oferta de trabajo. Entérate del perfil y los conocimientos solicitados, así como las responsabilidades del puesto, entre otros datos."
                                        popoverTitle="Detalles de la Oferta">
                                          <i class="feather ft-eye"></i>
                                        </button>
                                      </td>
                                      <td scope="row">{{ convertDate(egresado?.fechaPostulacion) }}</td>
                                      <td scope="row" *ngIf="egresado?.fechaAceptacion !='0001-01-01T00:00:00'">{{ convertDate(egresado?.fechaAceptacion) }}</td>
                                      <td scope="row" class="text-center" *ngIf="egresado?.fechaAceptacion =='0001-01-01T00:00:00'"> - - - - - - - - </td>
                                      <td scope="row">
                                        <div *ngIf="egresado?.descripcion == 'En espera'" class="badge badge-warning btn-block">
                                          <span> En revisión </span>
                                        </div>
                                        <div *ngIf="egresado?.descripcion == 'Aceptada'" class="badge badge-success btn-block">
                                          <span> Aceptado </span>
                                        </div>
                                        <div *ngIf="egresado?.descripcion == 'Rechazada'" class="badge badge-danger btn-block">
                                          <span> Rechazado </span>
                                        </div>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                            </div>
                          </div>
                          
                        </div>
                      </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <section id="offers-active" *ngIf="!hasSearch">
            <div class="col-md-12">
              <div class="card">
                <div class="card-header">
                  <h5 class="content-header-title card-title">Consulta el seguimiento de postulaciones de los egresados.</h5>
                </div>
                <div class="table-responsive card-body">
                  <div *ngIf="response?.data === null || response?.data.length === 0"
                    class="bs-callout-info callout-round callout-bordered mt-1">
                      <div class="media align-items-stretch">
                        <div class="d-flex align-items-center media-left media-middle bg-info callout-arrow-left position-relative p-2">
                          <i class="la la-ban white font-medium-5"></i>
                        </div>
                        <div class="media-body p-1">
                          <h4 class="info">No hay registros</h4>
                          <p>Aún no hay registro de postulaciones realizadas por los egresados.
                          </p>
                        </div>
                      </div>
                  </div>
    
                  <table *ngIf="response?.data != null || response?.data.length > 0"
                  class="table table-column table-hover">
                    <thead class="thead bg-blue1">
                      <tr>   
                        <th scope="col">
                          <h5 class="text-bold-600">Egresado</h5></th>                   
                        <th scope="col">
                          <h5 class="text-bold-600">Puesto</h5></th>
                        <th scope="col">
                          <h5 class="text-bold-600">Lugar</h5></th>
                        <th scope="col">
                          <h5 class="text-bold-600">Detalles Oferta</h5></th>
                        <th scope="col">
                          <h5 class="text-bold-600">Fecha de postulación</h5></th>
                        <th scope="col">
                          <h5 class="text-bold-600">Fecha de aceptación</h5></th>
                        <th scope="col" class="col-sm-3">
                          <h5 class="text-bold-600">Estado de vacante</h5></th>
                        </tr>
                    </thead>
                    <tbody *ngFor="let egresado of response?.data;">
                      <tr class="ng-star-inserted">
                        <td scope="row">{{ egresado?.nombre }}</td>
                        <td scope="row">{{ egresado?.descripcionPuesto }}</td>  
                        <th scope="row">{{ egresado?.lugar }}</th>
                        <td scope="row" class="text-center">
                          <button type="button" class="btn btn-icon btn-primary mr-1" (click)="openDetailOffer(egresado?.idOferta)"
                          triggers="hover:click:hover" placement="top"
                          ngbPopover="Consulta información más detallada acerca de la oferta de trabajo. Entérate del perfil y los conocimientos solicitados, así como las responsabilidades del puesto, entre otros datos."
                          popoverTitle="Detalles de la Oferta">
                            <i class="feather ft-eye"></i>
                          </button>
                        </td>
                        <td scope="row">{{ convertDate(egresado?.fechaPostulacion) }}</td>
                        <td scope="row" *ngIf="egresado?.fechaAceptacion !='0001-01-01T00:00:00'">{{ convertDate(egresado?.fechaAceptacion) }}</td>
                        <td scope="row" class="text-center" *ngIf="egresado?.fechaAceptacion =='0001-01-01T00:00:00'"> - - - - - - - - </td>
                        <td scope="row">
                          <div *ngIf="egresado?.descripcion == 'En espera'" class="badge badge-warning btn-block">
                            <span> En revisión </span>
                          </div>
                          <div *ngIf="egresado?.descripcion == 'Aceptada'" class="badge badge-success btn-block">
                            <span> Aceptado </span>
                          </div>
                          <div *ngIf="egresado?.descripcion == 'Rechazada'" class="badge badge-danger btn-block">
                            <span> Rechazado </span>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
    
                  <div *ngIf="response?.totalPages > 1"
                    class="d-flex justify-content-between p-2">
                    <div class="col-lg-6 col-md-12">
                      <nav aria-label="Navegador de páginas">
                        <ul class="pagination justify-content-star pagination-separate ">
                          <ngb-pagination 
                          [(page)]="currentPage" 
                          [collectionSize]="response?.totalRows" 
                          [pageSize]="response?.pageSize" 
                          (pageChange)="pageChange($event)"
                          class="d-flex justify-content-start"></ngb-pagination>
                        </ul>
                      </nav>              
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <br><br><br>
              </div>
            </div>
          </section>
          <div class="p-2 mt-2"></div>
        <div class="p-2 mt-2"></div>
        </div>
      </div>

    </div>
  </div>
  
  